import styled from 'styled-components';

/**
 * Wrapper para tabelas com scroll horizontal
 */
export const TableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    box-sizing: border-box;
`;

/**
 * Tabela base com estilo moderno
 */
export const StreamsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: ${(props) => props.minWidth || '600px'};
`;

/**
 * Célula de cabeçalho da tabela
 */
export const TableHead = styled.th`
    text-align: ${(props) => props.align || 'left'};
    font-size: 13px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #6b7280;
    padding: 12px 16px;
    border-bottom: 1px solid #e5e7eb;
    font-family: 'Mulish', sans-serif;
`;

/**
 * Linha da tabela com hover
 */
export const TableRow = styled.tr`
    border-bottom: 1px solid #eef2f7;
    transition: all 0.2s ease;

    &:hover {
        background: #f9fbff;
    }

    ${(props) => props.clickable && `
        cursor: pointer;
    `}
`;

/**
 * Célula da tabela
 */
export const TableCell = styled.td`
    padding: 12px 16px;
    color: #4c5968;
    font-size: 14px;
    font-family: 'Mulish', sans-serif;
    text-align: ${(props) => props.align || 'left'};
`;

/**
 * Célula de ações (alinhada à direita)
 */
export const TableActions = styled.td`
    padding: 12px 16px;
    text-align: right;
`;

/**
 * Cabeçalho de tabela simples (usado em algumas páginas)
 */
export const TableHeaderCell = styled.th`
    text-align: ${(props) => props.align || 'left'};
    padding: 12px 16px;
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #6b7280;
    font-family: 'Mulish', sans-serif;
`;

/**
 * Linha de título (usada em algumas páginas)
 */
export const TitleRow = styled.tr`
    background-color: #f5f5f5;
`;

/**
 * Linha de resultado (usada em algumas páginas)
 */
export const ResultRow = styled.tr`
    border-bottom: 1px solid #edf1f7;
    transition: background 0.2s ease;

    &:hover {
        background: #f9fbff;
    }

    ${(props) => props.clickable && `
        cursor: pointer;
    `}
`;

/**
 * Tabela simples (sem estilização avançada)
 */
export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: ${(props) => props.minWidth || '420px'};
`;

/**
 * Stack de ações (botões lado a lado)
 */
export const ActionStack = styled.div`
    display: flex;
    gap: 8px;
    justify-content: ${(props) => props.align || 'flex-end'};
`;

/**
 * Botão de ação com ícone (usado em tabelas)
 */
export const IconActionButton = styled.button`
    border: none;
    border-radius: 10px;
    width: 40px;
    height: 40px;
    background: ${(props) =>
        props.gradient ||
        'linear-gradient(135deg, #6b7280 0%, #4c1d95 100%)'
    };
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
        transform: translateY(-2px);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }
`;

/**
 * Botão de perigo (delete, remover)
 */
export const DangerButton = styled(IconActionButton)`
    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
`;
